var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "meet-experts-container content-max-width" },
    [
      _c("div", { staticClass: "search" }, [
        _c("div", { staticClass: "form-fields-stack" }, [
          _c("div", { staticClass: "form-field text search" }, [
            _c("label", [_vm._v("Search experts")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.payload.keyword,
                  expression: "payload.keyword"
                },
                {
                  name: "debounce",
                  rawName: "v-debounce:750ms",
                  value: _vm.loadKeywords,
                  expression: "loadKeywords",
                  arg: "750ms"
                }
              ],
              attrs: { type: "text", placeholder: "Start typing..." },
              domProps: { value: _vm.payload.keyword },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.payload, "keyword", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-field select" }, [
            _c("label", { attrs: { for: "" } }, [_vm._v("Filter by type")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.payload.occupation,
                    expression: "payload.occupation"
                  }
                ],
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.payload,
                      "occupation",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              _vm._l(_vm.filter, function(item) {
                return _c(
                  "option",
                  { key: item.id, domProps: { value: item.value } },
                  [
                    _vm._v(
                      "\n            " + _vm._s(item.label) + "\n          "
                    )
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-field select" }, [
            _c("label", { attrs: { for: "" } }, [_vm._v("Filter by region")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.payload.region,
                    expression: "payload.region"
                  }
                ],
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.payload,
                      "region",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              _vm._l(_vm.regions, function(region) {
                return _c(
                  "option",
                  { key: region.id, domProps: { value: region.value } },
                  [
                    _vm._v(
                      "\n            " + _vm._s(region.label) + "\n          "
                    )
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "button grey-border", on: { click: _vm.clearAll } },
            [
              _c("span", { staticClass: "icon-clear" }),
              _vm._v(" Clear filter\n      ")
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.experts.length
        ? _c(
            "div",
            { staticClass: "experts flex", attrs: { id: "exp-container" } },
            _vm._l(_vm.experts, function(person, index) {
              return _c("article", { key: index }, [
                _c(
                  "div",
                  {
                    staticClass: "wrap flex",
                    class: { active: person.name === _vm.activePerson.name },
                    attrs: { id: "container" + index },
                    on: {
                      click: function($event) {
                        return _vm.toggleInfo(index)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "name" }, [
                      _c("h3", [_vm._v(_vm._s(person.name))])
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: person.thumbnail,
                        alt: "Habit Health:" + person.name
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-container flex" }, [
                  _c(
                    "button",
                    {
                      staticClass: "close-dropdown",
                      on: {
                        click: function($event) {
                          _vm.activePerson = {}
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/images/icons/close.svg",
                          alt: "close dropdown button"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "image" }, [
                    _c("a", { attrs: { href: _vm.getUrl(person.name) } }, [
                      _c("img", {
                        attrs: {
                          src: person.hero,
                          alt: "Habit Health:" + person.name
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "info" }, [
                      _c("h3", [_vm._v(_vm._s(person.name))]),
                      _vm._v(" "),
                      _c("h4", [_vm._v(_vm._s(person.position))]),
                      _vm._v(" "),
                      _c(
                        "a",
                        { staticClass: "button", attrs: { href: person.link } },
                        [_vm._v("Book Now")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "wysiwyg",
                      domProps: { innerHTML: _vm._s(person.description) }
                    })
                  ])
                ])
              ])
            }),
            0
          )
        : _c("div", { staticClass: "experts flex flex-center" }, [_vm._m(0)]),
      _vm._v(" "),
      _vm.nextUrl
        ? _c(
            "div",
            {
              staticClass: "load-more content-max-width",
              attrs: { disabled: _vm.isDisabled },
              on: { click: _vm.loadMore }
            },
            [
              _c(
                "a",
                {
                  staticClass: "load-more-btn button large blue-border",
                  attrs: { href: "#load-more" }
                },
                [_vm._v("Load More")]
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", [
      _vm._v("We couldn't find that person. Try "),
      _c(
        "a",
        {
          staticStyle: {
            "font-family": "inherit",
            "font-size": "inherit",
            "font-weight": "inherit"
          },
          attrs: { href: "/contact-us" }
        },
        [_vm._v("contacting us")]
      ),
      _vm._v(" instead")
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3b05afc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3b05afc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/meet-experts/Index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e3b05afc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/meet-experts/Index.vue
// module chunks = 0